import * as React from 'react';

import { getTextWithoutParagraph } from 'utils';

import {
  Wrapper,
  Inner,
  Grid,
  ContentLeft,
  ContentRight,
  StyledTitle,
  Illustration,
} from './employee-rewards-features.styles';
import { Items } from './items';

export const FeaturesView = ({ title, items, illustration }) => (
  <Wrapper>
    <Inner>
      <Grid>
        <ContentLeft>
          <StyledTitle
            as="h2"
            size="xl"
            dangerouslySetInnerHTML={{
              __html: getTextWithoutParagraph(title),
            }}
          />
          <Items items={items} />
        </ContentLeft>
        <ContentRight>
          <Illustration fixed={illustration} />
        </ContentRight>
      </Grid>
    </Inner>
  </Wrapper>
);
